// ------------------------------------
// MENU
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'header-variables';
    const ref2 = 'header';

    // Elementos
    const $header = $('.header');
    const $headerContent = $('.header-content');
    const $menu = $('.header-menu');
    const $menuLista = $menu.find('ul');
    const $menuMobileBtn = $header.find('.menu-mobile-btn');

    // Oculta/Exibe o menu
    function changeMenuShow() {
      const value = confTheme[ref2]['menu-show'];
      value == '1' ? $menu.removeClass('d-none') : $menu.addClass('d-none');
      value == '1' ? $menuMobileBtn.removeClass('d-none') : $menuMobileBtn.addClass('d-none');
      value == '1' ? $headerContent.addClass('has-menu') : $headerContent.removeClass('has-menu');
    }
    $root.on(confEvtDefault + ' lp-evt-header-menu-show', changeMenuShow);

    // Cor de fundo
    function changeMenuBgColor() {
      const color = confTheme[ref]['menu-bg-color'];
      //$header[0].style.setProperty('--menu-bg-color', color);
      $header.each(function () {
        this.style.setProperty('--menu-bg-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-menu-bg-color', changeMenuBgColor);

    // Cor do texto
    function changeMenuTxtColor() {
      const color = confTheme[ref]['menu-txt-color'];
      //$header[0].style.setProperty('--menu-txt-color', color);
      $header.each(function () {
        this.style.setProperty('--menu-txt-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-menu-txt-color', changeMenuTxtColor);

    // Cor do texto mobile
    function changeMenuTxtColorMb() {
      const color = confTheme[ref]['menu-mb-txt-color'];
      //$header[0].style.setProperty('--menu-mb-txt-color', color);
      $header.each(function () {
        this.style.setProperty('--menu-mb-txt-color', color);
      });
    }
    $root.on(confEvtDefault + ' lp-evt-header-menu-mb-txt-color', changeMenuTxtColorMb);

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['menu-links'];
      if ($menuLista.length > 0) {
        $menuLista.html('');
        for (let i = 0; i < lista.length; i++) {
          const menuDataInst = lista[i].tipo_link == 'institucional' ? 'data-modal-pag="' + lista[i].url + '"' : '';
          const item = `<li><a href="${lista[i].url}" ${menuDataInst}>${lista[i].titulo}</a></li>`;
          $menuLista.append(item);
        }
      }
    }
    $root.on(confEvtDefault + ' lp-evt-header-menu-lista', changeList);
  }
})();
